export const CONTACTS_AVATARS_LOAD_REQUEST = 'CONTACTS_AVATARS_LOAD_REQUEST';
export const CONTACTS_AVATARS_LOAD_SUCCESS = 'CONTACTS_AVATARS_LOAD_SUCCESS';
export const CONTACTS_AVATARS_LOAD_FAILS = 'CONTACTS_AVATARS_LOAD_FAILS';
